import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const AddTag = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [status, setStatus] = useState('');

  const validateForm = () => {
    if (!name.trim()) {
      toast.error('Name is required.');
      return false;
    }
    if (!status) {
      toast.error('Status is required.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const payload = {
        name,
        status,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/tags/create-tag`,
        payload
      );

      if (response.data.success) {
        toast.success('Tag created successfully!');
        setTimeout(() => navigate('/tags'), 3000);
      } else {
        toast.error('Could not create tag');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <ToastContainer />
      <div className="shadow rounded" style={cardStyle}>
        <div style={sectionTitleStyle}>
          <h3 style={titleTextStyle}>Add Tag</h3>
        </div>
        <div style={userInfoContainer}>
          {/* Name Field */}
          <div style={profileFieldStyle}>
            <label style={profileLabelStyle}>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={profileInputStyle}
              placeholder="Enter tag name"
              maxLength={30}
              required
            />
          </div>

          {/* Status Dropdown */}
          <div style={profileFieldStyle}>
            <label style={profileLabelStyle}>Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={profileInputStyle}
              required
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="add-btn-align-category">
        <Button
          type="submit"
          style={buttonStyle}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? 'Adding...' : 'Add'}
        </Button>
      </div>
    </div>
  );
};

// Styles
const containerStyle = {
  maxWidth: '90%',
  fontFamily: 'Poppins',
  fontWeight: 600,
};

const cardStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  marginBottom: '20px',
  border: 'none',
  width: '80%',
};

const sectionTitleStyle = {
  color: 'white',
  backgroundColor: '#064260',
  padding: '10px',
  borderRadius: '8px 8px 0 0',
  textAlign: 'left',
  fontWeight: 600,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const titleTextStyle = {
  fontSize: '21px',
  margin: 0,
};

const buttonStyle = {
  backgroundColor: '#27B99A',
  color: 'white',
  border: 'none',
  borderRadius: '20px',
  fontSize: '16px',
  cursor: 'pointer',
  width: '15%',
  marginRight: '30px',
};

const userInfoContainer = {
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 40px',
  gap: '20px',
};

const profileFieldStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

const profileLabelStyle = {
  fontWeight: 'bold',
  fontSize: '14px',
};

const profileInputStyle = {
  padding: '8px',
  borderRadius: '4px',
  backgroundColor: '#F4F4F6',
  border: 'none',
  width: '100%',
};

export default AddTag;
